import React from "react";
import { useI18n } from "../../lib/i18n.jsx";

const LOGO_DARK = "https://i.imgur.com/kTC8GsU.png";

export default function Footer({ onOpenQuote, onOpenDistribuye, onOpenRegistro }) {
  const { t } = useI18n();
  return (
    <footer
      id="pie"
      className="bg-[#0e2618] text-[#f7f7f4]/80 pt-20 pb-10"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <img src={LOGO_DARK} alt="Euzerone" className="h-12 w-auto rounded" />
          <p className="mt-6 max-w-md text-[#9ead9b] leading-relaxed">
            {t.footer.tagline}
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <button
              onClick={onOpenQuote}
              className="inline-flex items-center gap-2 bg-[#b45f3e] hover:bg-[#a04f31] text-[#f7f7f4] rounded-full px-6 py-3 font-medium transition"
              data-testid="footer-quote-btn"
            >
              <i className="fa-solid fa-leaf"></i>
              {t.nav.quote}
            </button>
            <button
              onClick={onOpenDistribuye}
              className="inline-flex items-center gap-2 border border-[#9ead9b]/40 hover:border-[#9ead9b] text-[#f7f7f4] rounded-full px-6 py-3 font-medium transition"
              data-testid="footer-distribuye-btn"
            >
              <i className="fa-solid fa-handshake"></i>
              Ser distribuidor
            </button>
            <button
              onClick={onOpenRegistro}
              className="inline-flex items-center gap-2 border border-[#9ead9b]/40 hover:border-[#9ead9b] text-[#f7f7f4] rounded-full px-6 py-3 font-medium transition"
              data-testid="footer-registro-btn"
            >
              <i className="fa-solid fa-seedling"></i>
              Regístrate
            </button>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="eu-data-label text-[#9ead9b] mb-4">
            {t.footer.products}
          </div>
          <ul className="space-y-2 text-sm">
            <li><a href="#productos" className="hover:text-[#f7f7f4] transition">Engorde Complet</a></li>
            <li><a href="#productos" className="hover:text-[#f7f7f4] transition">Nautic</a></li>
            <li><a href="#productos" className="hover:text-[#f7f7f4] transition">Nuster Flower</a></li>
            <li><a href="#productos" className="hover:text-[#f7f7f4] transition">Hierro 6-48</a></li>
            <li><a href="#productos" className="hover:text-[#f7f7f4] transition">Molibdeno Eco</a></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="eu-data-label text-[#9ead9b] mb-4">
            {t.footer.contact}
          </div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-envelope text-[#b45f3e]"></i>
              <a href="mailto:info@euzerone.com" className="hover:text-[#f7f7f4]">
                info@euzerone.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-phone text-[#b45f3e]"></i>
              <a href="tel:+34933801596" className="hover:text-[#f7f7f4]">
                (+34) 933 80 15 96
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-brands fa-whatsapp text-[#b45f3e]"></i>
              <a
                href="https://wa.me/34637737339"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#f7f7f4]"
              >
                (+34) 637 73 73 39
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-location-dot text-[#b45f3e]"></i>
              <span>Barcelona, España</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#f7f7f4]/10 mt-16 pt-8 max-w-7xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-[#9ead9b]">
        <div>© {new Date().getFullYear()} EUZERONE. {t.footer.rights}</div>
        <div className="font-mono-eu tracking-widest">PROFESSIONAL · USE · ONLY</div>
      </div>
    </footer>
  );
}
